import { Button, Dropdown, MenuProps, Row } from "antd";
import { MoreOutlined, ExportOutlined } from "@ant-design/icons";
import { useExportExcel } from "../../../../lib/hooks/exportExcel";
import { useCallback, useMemo, useState } from "react";
import { CreateAccountModal } from "./CreateAccountModal";
import ContractsService from "../../../../services/accounts/contracts";
import { usePermissions } from "../../../../lib/hooks/usePermissions";

type AdminActionsProps = {
  request: any;
  isOther: boolean;
};

export const AdminActions = ({ request, isOther }: AdminActionsProps) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

  const { hasAccessByController } = usePermissions("Contracts");
  const { hasAccess } = usePermissions();

  const { onExportExcelButtonClicked, isLoading: isExportLoading } =
    useExportExcel(ContractsService, request, "accounts.xlsx");

  const openCreateModal = useCallback(
    (): void => setIsCreateModalOpen(true),
    [],
  );

  const showCreate: boolean = useMemo(
    () => !isOther && hasAccessByController("Add"),
    [hasAccessByController, isOther],
  );

  const moreActions: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={onExportExcelButtonClicked}>Export</Row>,
      },
    ],
    [onExportExcelButtonClicked],
  );

  return (
    <div>
      {hasAccess("Export", "Contracts") && (
        <>
          {!isOther ? (
            <Dropdown
              menu={{ items: moreActions }}
              disabled={isExportLoading}
              trigger={["click"]}
              className="mr-4"
            >
              <Button icon={<MoreOutlined />} shape="circle" />
            </Dropdown>
          ) : (
            <Button
              shape="round"
              onClick={onExportExcelButtonClicked}
              disabled={isExportLoading}
              className="mr-4"
            >
              <ExportOutlined />
              Export
            </Button>
          )}
        </>
      )}
      {showCreate && (
        <>
          <Button shape="round" type="primary" onClick={openCreateModal}>
            Create Account
          </Button>

          <CreateAccountModal
            isModalOpen={isCreateModalOpen}
            setIsModalOpen={setIsCreateModalOpen}
          />
        </>
      )}
    </div>
  );
};
